import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const BLOOD_GROUP_PATH = "/master/v1/blood-group";

export const getBloodGroupApi = async (params) =>
  await getRequest(BLOOD_GROUP_PATH, params);

export const getBloodGroupByIdApi = async (id) =>
  await getRequest(`${BLOOD_GROUP_PATH}/${id}`);

export const addBloodGroupApi = async (body) =>
  await postRequest(BLOOD_GROUP_PATH, body);

export const updateBloodGroupApi = async (body) =>
  await putRequest(`${BLOOD_GROUP_PATH}/${body?._id}`, body);

export const deleteBloodGroupByIdApi = async (id) =>
  await deleteRequest(`${BLOOD_GROUP_PATH}/${id}`);
